import React, { useState, useCallback, useEffect } from 'react';
import {
  Grid,
  TextField,
} from '@material-ui/core';
import { CustomAutocomplete } from '~/components/CustomAutocomplete';

import {
    listHinovaProducts,
    listHinovaRegionais,
    listHinovaCooperativas,
    listHinovaTiposVeiculo,
} from '~/services/api';
import { handleApiErrorResponse } from '~/services/handleErrors';
import {
    HinovaProduct,
    HinovaRegional,
    HinovaCooperativa,
    HinovaTipoVeiculo,
} from '~/types';

import { Table } from '~/components/Table';
import InputComponent from '~/components/InputComponent';
import Button from '~/components/Button';
import Snackbar from '~/components/Snackbar/index';
import { SeverityType } from '~/components/Snackbar/index';

export default function ProductSearch() {
  const [codigoRegional, setCodigoRegional] = useState<string>('');
  const [codigoCooperativa, setCodigoCooperativa] = useState<string>('');
  const [codigoTipoVeiculo, setCodigoTipoVeiculo] = useState<string>('');

  const [regionais, setRegionais] = useState<HinovaRegional[]>([]);
  const [cooperativas, setCooperativas] = useState<HinovaCooperativa[]>([]);
  const [tiposVeiculo, setTiposVeiculo] = useState<HinovaTipoVeiculo[]>([]);


  const [valorFipe, setValorFipe] = useState<string>('');
  const [cilindrada, setCilindrada] = useState<string>('');
  const [products, setProducts] = useState<HinovaProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [severity, setSeverity] = useState<SeverityType>('info');
  const [openSnackbar, setOpenSnackbar] = useState(false);




  useEffect(() => {
  async function loadData() {
    try {
      const [
        regionaisResponse,
        cooperativasResponse,
        tiposResponse,
      ] = await Promise.all([
        listHinovaRegionais(),
        listHinovaCooperativas(),
        listHinovaTiposVeiculo('ativo'),
      ]);

      if (regionaisResponse.status === 200) {
        console.log(regionaisResponse.data);
        setRegionais(
          Array.isArray(regionaisResponse.data)
            ? regionaisResponse.data
            : regionaisResponse.data.data || [],
        );
      }

      if (cooperativasResponse.status === 200) {
        console.log(regionaisResponse.data);
        setCooperativas(
          Array.isArray(cooperativasResponse.data)
            ? cooperativasResponse.data
            : cooperativasResponse.data.data || [],
        );
      }

      if (tiposResponse.status === 200) {
        console.log(regionaisResponse.data);
        setTiposVeiculo(
          Array.isArray(tiposResponse.data)
            ? tiposResponse.data
            : tiposResponse.data.data || [],
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  loadData();
}, []);



  const searchProducts = useCallback(async () => {
    if (!codigoRegional || !codigoCooperativa || !codigoTipoVeiculo || !valorFipe || !cilindrada) {
      setSeverity('warning');
      setMessageSnack('Por favor, preencha todos os campos obrigatórios.');
      setOpenSnackbar(true);
      return;
    }


    // VALIDAÇÃO CÓDIGO FIPE.
    /////////////////////////


    if (!/^\d+\.\d{2}$/.test(valorFipe)) {
      setSeverity('warning');
      setMessageSnack('Formato VALOR FIPE inválido. Ex: 9999.99.');
      setOpenSnackbar(true);
      return;
    }


    //////////////////////////
    
    try {
      setLoading(true);
      const response = await listHinovaProducts(
        codigoRegional,
        codigoCooperativa,
        codigoTipoVeiculo,
        valorFipe,
        cilindrada,
      );

      if (response.status === 200 && response.data) {
        const data = response.data;
        const productsData = Array.isArray(data) ? data : [data];
        setProducts(productsData);
      } else {
        setProducts([]);
      }
    } catch (err) {
      const error = handleApiErrorResponse(err);
      setSeverity('warning');
      setMessageSnack(
        (error?.applicationErrorMessage || error?.apiError) + ': não foi possível pesquisar produtos. Tente novamente.',
      );
      setOpenSnackbar(true);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [codigoRegional, codigoCooperativa, codigoTipoVeiculo, valorFipe, cilindrada]);

  return (
    <>
      <Grid container spacing={2} style={{ marginBottom: 20 }} alignItems='flex-end'>
      <Grid item xs={12} sm={6} md={4}>
        <CustomAutocomplete
          options={regionais}
          getOptionLabel={(option) => (option as HinovaRegional).nome ?? ''}
          getOptionSelected={(option, value) =>
            (option as HinovaRegional).codigo_regional ===
            (value as HinovaRegional).codigo_regional
          }
          value={
            regionais.find(
              r => String(r.codigo_regional) === codigoRegional
            ) || null
          }
            onChange={(_, value) => {
              const regional = value as HinovaRegional | null;

              if (regional?.codigo_regional) {
                setCodigoRegional(String(regional.codigo_regional));
              }
            }}


          renderInput={(params) => (
            <TextField
              {...params}
              label="Regional"
              variant="outlined"
            />
          )}
        />
      </Grid>


    <Grid item xs={12} sm={6} md={4}>
      <CustomAutocomplete
        options={cooperativas}
        getOptionLabel={(option) => (option as HinovaCooperativa).nome ?? ''}
        getOptionSelected={(option, value) =>
          (option as HinovaCooperativa).codigo_cooperativa ===
          (value as HinovaCooperativa).codigo_cooperativa
        }
        value={
          cooperativas.find(
            c => String(c.codigo_cooperativa) === codigoCooperativa
          ) || null
        }
          onChange={(_, value) => {
            const cooperativa = value as HinovaCooperativa | null;

            if (cooperativa?.codigo_cooperativa) {
              setCodigoCooperativa(String(cooperativa.codigo_cooperativa));
            }
          }}


        renderInput={(params) => (
          <TextField
            {...params}
            label="Cooperativa"
            variant="outlined"
          />
        )}
      />
    </Grid>



    <Grid item xs={12} sm={6} md={4}>
      <CustomAutocomplete
        options={tiposVeiculo}
        getOptionLabel={(option) =>
          (option as HinovaTipoVeiculo).descricao_tipo ?? ''
        }
        getOptionSelected={(option, value) =>
          (option as HinovaTipoVeiculo).codigo_tipo ===
          (value as HinovaTipoVeiculo).codigo_tipo
        }
        value={
          tiposVeiculo.find(
            t =>
              String(t.codigo_tipo) ===
              codigoTipoVeiculo
          ) || null
        }
        onChange={(_, value) => {
          const tipo = value as HinovaTipoVeiculo | null;

          if (tipo?.codigo_tipo) {
            setCodigoTipoVeiculo(String(tipo.codigo_tipo));
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tipo de Veículo"
            variant="outlined"
          />
        )}
      />
    </Grid>


        <Grid item xs={12} sm={6} md={4}>
          <InputComponent
            label='(FIPE)'
            name='valorFipe'
            type='text'
            value={valorFipe}
            onChange={e => {
              const value = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(value)) {
                setValorFipe(value);
              }
            }}
            error={null}
            placeholder='Valor do veículo (FIPE)'
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InputComponent
            label='Cilindrada'
            name='cilindrada'
            type='text'
            value={cilindrada}
            onChange={e => setCilindrada(e.target.value)}
            error={null}
            placeholder='Cilindrada do motor'
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            label='Pesquisar'
            loading={loading}
            onClick={searchProducts}
            filled
            style={{ width: '100%', marginTop: 0 }}
          />
        </Grid>
      </Grid>


      <Table
        isLoading={loading}
        data={products}
        columns={{
          codigo_produto: {
            title: 'Código',
          },
          decricao_produto: {
            title: 'Descrição',
            render: rowData => rowData.decricao_produto || '-',
          },
          valor_produto: {
            title: 'Valor',
            render: rowData => (rowData.valor_produto ? `R$ ${rowData.valor_produto}` : '-'),
          },
          descricao_tipo_veiculo: {
            title: 'Tipo de Veículo',
            render: rowData => rowData.descricao_tipo_veiculo || '-',
          }

        }}
        
        localization={{
          body: {
            emptyDataSourceMessage: loading
              ? 'Carregando...'
              : 'Nenhum produto encontrado. Preencha todos os campos e tente novamente.',
          },
          pagination: {
            labelRowsSelect: 'produtos',
          },
        }}
        options={{
          showTitle: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50],
          paging: true,
          filtering: false,
          search: false,
        }}
      />

      <Snackbar message={messageSnack} open={openSnackbar} severity={severity} onClose={() => setOpenSnackbar(false)} />
    </>
  );
}








